import { Table } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import type { SuppliersBalanceColumnDef } from '../../../../hooks/useSuppliersBalanceTableColumns'

interface TotalsFooterRowProps {
  columns: SuppliersBalanceColumnDef[]
}

export const TotalsFooterRow = ({ columns }: TotalsFooterRowProps): ReactElement => (
  <Table.Row data-totals-row highlighted>
    {columns.map((column) => (
      <Table.Cell key={column.id} align={column.align}>
        {column.Footer?.()}
      </Table.Cell>
    ))}
  </Table.Row>
)
